var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c("system", { attrs: { leftList: _vm.leftList } }),
      _vm._v(" "),
      _c("div", { staticClass: "pageBox" }, [
        _c(
          "div",
          { staticClass: "breadcrumb" },
          [
            _c(
              "el-breadcrumb",
              { attrs: { separator: "/" } },
              [
                _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                  _vm._v("首页"),
                ]),
                _vm._v(" "),
                _c("el-breadcrumb-item", [_vm._v("用户详情")]),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "pageTab" }, [
          _c(
            "div",
            {
              staticClass: "modelTitle",
              staticStyle: { "margin-top": "30px" },
            },
            [_vm._v("任务信息")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "modelDetail" }, [
            _c("div", { staticClass: "infoItem" }, [
              _vm._v("任务名称：" + _vm._s(_vm.detail.jobTitle)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "infoItem" }, [
              _vm._v("客户名称：" + _vm._s(_vm.detail.customName)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "infoItem" }, [
              _vm._v("创建时间：" + _vm._s(_vm.detail.callAt)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "infoItem" }, [
              _vm._v("完成时间：" + _vm._s(_vm.detail.wantCallAt)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "infoItem" }, [
              _vm._v("负责回访人：" + _vm._s(_vm.detail.nickname)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "infoItem" }, [
              _vm._v(
                "\n          回访状态：" +
                  _vm._s(
                    _vm.detail.status == 0
                      ? "未完成"
                      : _vm.detail.status == 1
                      ? "回访中"
                      : "已完成"
                  ) +
                  "\n        "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "modelTitle",
              staticStyle: { "margin-top": "30px" },
            },
            [_vm._v("记录列表")]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { "margin-top": "30px" } },
            [
              _c(
                "el-tabs",
                {
                  attrs: { type: "border-card" },
                  on: { "tab-click": _vm.handleClick },
                },
                [
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "回访记录" } },
                    [
                      _c(
                        "el-table",
                        {
                          ref: "scrollTable",
                          staticStyle: { width: "100%" },
                          attrs: { data: _vm.tableData, border: "" },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              prop: "id",
                              label: "编号",
                              align: "center",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "userName",
                              label: "回访人",
                              align: "center",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "wantCallAt",
                              label: "回访时间",
                              align: "center",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "回访内容", align: "center" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(_vm._s(scope.row.memo)),
                                    ]),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "回访状态", align: "center" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(_vm._s(scope.row.memo)),
                                    ]),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("el-pagination", {
                        attrs: {
                          "page-sizes": [10, 20, 30, 50],
                          "page-size": _vm.pageSize,
                          layout: "total, prev, pager, next,sizes",
                          total: _vm.total,
                        },
                        on: {
                          "size-change": _vm.handleSizeChange,
                          "current-change": _vm.handleCurrentChange,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }